export const ADD_WORKSPACE = 'ADD_WORKSPACE'
export const REMOVE_WORKSPACE = 'REMOVE_WORKSPACE'
export const UPDATE_WORKSPACE = 'UPDATE_WORKSPACE'
export const SET_ACTIVE_WORKSPACE = 'SET_ACTIVE_WORKSPACE'
export const REARRANGE_WORKSPACE = 'REARRANGE_WORKSPACE'
export const SET_WORKSPACE_DATA = 'SET_WORKSPACE_DATA'
export const LAUNCH_APP = 'LAUNCH_APP'
export const SET_CURRENT_APP = 'SET_CURRENT_APP'
export const SET_LAUNCHING_WORKSPACE = 'SET_LAUNCHING_WORKSPACE'
